module.exports = __webpack_public_path__ + "static/media/nb_add_to_google_wallet.0220c67b.svg";